// This function allow to reference all chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "" + {"668":"css/app.6941","8729":"css/admin-app.6941"}[chunkId] + ".css";
};